import React from 'react';
import './FilterPanel.css';

const FilterPanel = ({ filters, onFilterChange, regions }) => {
  const statusOptions = [
    { value: 'all', label: '전체 상태' },
    { value: 'NORMAL', label: '정상' },
    { value: 'PARTIAL_ERROR', label: '부분 오류' },
    { value: 'COMMUNICATION_ERROR', label: '통신 오류' }
  ];

  const allRegions = ['서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종', '경기', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'];
  
  const regionOptions = [
    { value: 'all', label: '전체 지역' },
    ...allRegions.map(region => ({ value: region, label: region }))
  ];

  return (
    <div className="filter-panel">
      <h3>필터 및 검색</h3>
      
      <div className="filter-group">
        <label htmlFor="region-filter">지역</label>
        <select
          id="region-filter"
          value={filters.region}
          onChange={(e) => onFilterChange('region', e.target.value)}
          className="filter-select"
        >
          {regionOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="status-filter">상태</label>
        <select
          id="status-filter"
          value={filters.status}
          onChange={(e) => onFilterChange('status', e.target.value)}
          className="filter-select"
        >
          {statusOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="search-input">발전소 이름 검색</label>
        <input
          id="search-input"
          type="text"
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          placeholder="발전소 이름을 입력하세요"
          className="filter-input"
        />
      </div>

      <div className="filter-actions">
        <button
          onClick={() => onFilterChange('region', 'all')}
          className="clear-button"
        >
          필터 초기화
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
